import Loading from '@/components/Loading';
import { PdfReport } from '@/screens/PdfReport';
import { RequestInvalid } from '@/screens/RequestInvalid';
import LoadingLayer from '@/screens/utils/LoadingLayer';
import { useAuth } from '@hooks/Authentication/auth';
import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import AppRoutes from './app.routes';
import ExternalRoutes from './groups/external.routes';
import PublicRoutes from './public.routes';
import PolicyRoutes from './policy.routes';
import TaskOpenRedirector from '@/screens/registrations/Tasks/TaskOpenRedirector';

const Routes: React.FC = () => {
  const { token, loading } = useAuth();
  const { pathname, state } = useLocation();

  const getState = () => {
    if (state?.from) {
      return { from: state?.from };
    }
    return pathname.startsWith('/app') ? { from: pathname } : undefined;
  };

  if (loading) return <Loading />;

  return (
    <>
      <LoadingLayer />
      <Switch>
        <Route path="/app" component={AppRoutes} />
        <Route path="/auth" component={PublicRoutes} />
        <Route
          path="/tasks/:taskId/open"
          component={TaskOpenRedirector}
        />
        <Route path="/external" component={ExternalRoutes} />
        <Route path="/policy" component={PolicyRoutes} />
        <Route path="/request-invalid" component={RequestInvalid} />
        <Route
          path={
            pathname.includes('formulary_questions')
              ? '/pdf_reports/:workspaceSlug/:formulary_question/:reportId/:token'
              : '/pdf_reports/:workspaceSlug/:reportId/:token'
          }
          component={PdfReport}
        />
        {!pathname.includes('pdf_reports') && !pathname.includes('policy') && (
          <Route path="*">
            <Redirect
              to={{
                pathname: token ? '/app' : `/auth`,
                state: getState(),
              }}
            />
          </Route>
        )}
      </Switch>
    </>
  );
};

export default Routes;
